import { useContext } from 'react';
import { UserContext } from 'providers/User';
import { UserProfile, Permission } from 'types/user';
import { ROLES } from 'constants/roles';

interface User {
  profile?: UserProfile & { predictions_access?: boolean };
  active?: boolean;
}

interface UserContextType {
  user: User;
  updateData: (data: Partial<User>) => void;
  error: any;
}

export const useUser = (): UserContextType => {
  const context = useContext(UserContext);
  
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  
  return context;
};

export const useUserProfile = (): (UserProfile & { predictions_access?: boolean }) | null => {
  const { user } = useUser();
  return user?.profile || null;
};

export const useHasPermissions = (permissions: Permission[]): boolean => {
  const { user } = useUser();
  const userPermissions = user?.profile?.role?.permissions || [];
  return permissions.every(permission => userPermissions.includes(permission));
};

export const useIsSuperbUser = (): boolean => {
  const profile = useUserProfile();
  return Boolean(profile?.is_superb_user);
};

export const useIsAdmin = (): boolean => {
  const profile = useUserProfile();
  const userRole = profile?.role?.name;
  return Boolean(
    userRole === ROLES.ADMIN ||
    userRole === ROLES.SUPERB_ADMIN
  );
};